import arrayMove from 'array-move';

const useProductCarousel = () => {
  const handleOnReselect = (value, onChange, products) => {
    if (onChange) {
      const _products = products.map((i) => {
        return { ...i, draggableId: i.uuid };
      });
      onChange(_products);
    }
  };

  const handleOnDelete = (value, onChange, index) => {
    const nValue = (value || []).filter((_, i) => {
      return i !== index;
    });
    onChange(nValue);
  };
  const handleOnSort = (value, onChange, from, to) => {
    const nValue = arrayMove(value || [], from, to);
    onChange(nValue);
  };
  return {
    handleOnDelete,
    handleOnSort,
    handleOnReselect,
  };
};
export { useProductCarousel };
